module.exports = __webpack_public_path__ + "static/media/5DPO17.59925ae3.jpg";